// Copyright 2024 Sorama B.V.
import { Color } from "services/Color/Color";

/** Used to assign colors to measurements while being able to reference to colours by name */
export class NamedColor {
    public readonly name: string;
    public readonly color: Color;

    constructor(name: string, color: Color) {
        this.name = name;
        this.color = color;
    }

    public copy(): NamedColor {
        return new NamedColor(this.name, this.color.copy());
    }
}
